import React, { Component } from 'react'
import Icon from '../../shared/Icon'
import styles from './AdvancedSearchForm.scss'
import CSSModules from 'react-css-modules'

class AdvancedSearchField extends Component {
    constructor(props) {
        super(props);
    }

    handleChange(e) {
        if(!!e.target.value) {
            this.clearButton.style.visibility = 'visible';
        } else {
            this.clearButton.style.visibility = 'hidden';
        }
        this.render();
    }

    resetField() {
        this.inputField.value = '';
        this.clearButton.style.visibility = 'hidden';
    }
    
    componentDidMount() {
        this.inputField = document.getElementById(`extended-search-field-${this.props.field}`);
        this.clearButton = document.getElementsByClassName(`extended-search-field-${this.props.field}-clear`)[0];
    }
    
    render() {
        return (
            <li styleName="extended-search-item">
                <i styleName="extended-search-icon">
                    <Icon styleName="search-icon-ico" icon="Vitra_Search.svg" />
                </i>
                <input styleName="extended-search-field"
                       id={ `extended-search-field-${this.props.field}` }
                       type="text"
                       placeholder={ this.props.placeholderText }
                       disabled={ !!this.props.isDisabled ? "disabled" : null }
                       onChange={ (e) => this.handleChange(e) }
                       pattern={ ['searchYearFrom', 'searchYearTo'].indexOf(this.props.field) > -1 ? '[0-9]{4}' : null }
                />
                <button type="button"
                        className={ `extended-search-field-${this.props.field}-clear` }
                        styleName="extended-search-clear"
                        style={{visibility: 'hidden'}}
                        onClick={ () => this.resetField() }
                >
                    <Icon styleName="icon-close" icon="Vitra_Close.svg" tabindex="-1" />
                </button>
            </li>
        )
    }
}

export default CSSModules(AdvancedSearchField, styles);


// WEBPACK FOOTER //
// ./app/components/Main/AdvancedSearchForm/AdvancedSearchField.jsx